import state from './encoder.state'
import mutations from './encoder.mutations'
import actions from './encoder.actions'

export default {
  state,
  mutations,
  actions
}
